// ABOUTME: Owns the shareable plan link param (?plan=<planID>)
// ABOUTME: One format for the row that writes the link and the loader that reads it back

import { PLAN_URL_PARAM } from "./calendarLinkParams"

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export { PLAN_URL_PARAM }

/** The plan whose window the address asks for, or null when it asks for none. */
export const parsePlanUrl = (search: string): string | null => {
  const planID = new URLSearchParams(search).get(PLAN_URL_PARAM)
  return planID && UUID_RE.test(planID) ? planID : null
}

export const buildPlanSearch = (search: string, planID: string | null): string => {
  const params = new URLSearchParams(search)

  if (planID) params.set(PLAN_URL_PARAM, planID)
  else params.delete(PLAN_URL_PARAM)

  const next = params.toString()
  return next ? `?${next}` : ""
}
